import mapboxgl, { GeoJSONSource } from "mapbox-gl";
import { addAllLayersInOrder } from "./layers";
import { neighborsSources } from "./sources";
import { NeighborPickupsRow } from "../../../api/models/NeighborPickupsRow";
import { NeighborPickupsList } from "../../../api/models/NeighborPickupsList";
import { point, CoordinateObject } from "../../map/convert/geojson";
import * as uuid from "uuid";

export const convert = (reports: NeighborPickupsRow[]): NeighborSourceData => {
    let goNG: any;
    let goOK: any;
    let cruiseNG: any;
    let cruiseOK: any;
    let nOK: any;

    if (!reports) {
        return {
            goNG: null,
            goOK: null,
            cruiseNG: null,
            cruiseOK: null,
            nOK: null,
        };
    }

    const _nonok = reports.filter((x) => {
        return x.neighborPickupStatus !== "neighbor_pickup_found";
    });

    const _ok = reports.filter((x) => {
        return x.neighborPickupStatus === "neighbor_pickup_found";
    });

    if (_nonok) {
        console.warn("NEIGHBORS HAD SOME NOT OK VALS:", _nonok);
        nOK = _nonok;
    }

    if (_ok) {
        const goNgs = _ok.filter((x) => {
            return (
                x.neighborBoardingType == "pick_up_go" && x.checkSpeed == "NG"
            );
        });

        const goOks = _ok.filter((x) => {
            return (
                x.neighborBoardingType == "pick_up_go" && x.checkSpeed == "OK"
            );
        });

        const crNgs = _ok.filter((x) => {
            return x.neighborBoardingType == "cruise" && x.checkSpeed == "NG";
        });

        const crOks = _ok.filter((x) => {
            return x.neighborBoardingType == "cruise" && x.checkSpeed == "OK";
        });

        if (goNgs) {
            const _goNG = goNgs.map((x: NeighborPickupsRow) => {
                const loc = x.pickupLocCoords as any;
                return {
                    ...x,
                    coordinates: loc.shape,
                    id: uuid.v4(),
                };
            });
            goNG = point(_goNG as CoordinateObject[]);
        }
        if (goOks) {
            const _goOK = goOks.map((x: NeighborPickupsRow) => {
                const loc = x.pickupLocCoords as any;
                return {
                    ...x,
                    coordinates: loc.shape,
                    id: uuid.v4(),
                };
            });
            goOK = point(_goOK as CoordinateObject[]);
        }
        if (crNgs) {
            const _cruiseNG = crNgs.map((x: NeighborPickupsRow) => {
                const loc = x.pickupLocCoords as any;
                return {
                    ...x,
                    coordinates: loc.shape,
                    id: uuid.v4(),
                };
            });
            cruiseNG = point(_cruiseNG as CoordinateObject[]);
        }
        if (crOks) {
            const _cruiseOK = crOks.map((x: NeighborPickupsRow) => {
                const loc = x.pickupLocCoords as any;
                return {
                    ...x,
                    coordinates: loc.shape,
                    id: uuid.v4(),
                };
            });
            cruiseOK = point(_cruiseOK as CoordinateObject[]);
        }
    }

    return { goNG, goOK, cruiseOK, cruiseNG, nOK } as NeighborSourceData;
};

// TODO: no time right now, but fix the any vals
export interface NeighborSourceData {
    goNG: any;
    goOK: any;
    cruiseOK: any;
    cruiseNG: any;
    nOK: any;
}

export const show = async (
    map: mapboxgl.Map,
    report: NeighborPickupsList | null
): Promise<void> => {
    if (!report || !report.neighborReports) {
        console.debug(
            "Neighbors report will not show - no report was selected."
        );
        return;
    }

    const { goNG, goOK, cruiseOK, cruiseNG, nOK } = convert(
        report.neighborReports
    );

    console.debug("Setting source data... cruiseNG", cruiseNG);
    (map.getSource(
        neighborsSources.neighborsCruiseNGSrc
    ) as GeoJSONSource).setData(cruiseNG);

    console.debug("Setting source data... cruiseOK", cruiseOK);
    (map.getSource(
        neighborsSources.neighborsCruiseOKSrc
    ) as GeoJSONSource).setData(cruiseOK);

    console.debug("Setting source data... goNG", goNG);
    (map.getSource(neighborsSources.neighborsGoNGSrc) as GeoJSONSource).setData(
        goNG
    );

    console.debug("Setting source data... goOK", goOK);
    (map.getSource(neighborsSources.neighborsGoOKSrc) as GeoJSONSource).setData(
        goOK
    );

    addAllLayersInOrder(map);
};
